import React from 'react';
import { NavBarScreen } from '../navBar/NavBarScreen';
import { FooterScreen } from '../footer/FooterScreen';

export const TigerClub = () => {
    return (
        <>
            <NavBarScreen />

            <div className="tiger-club-container">
                <br />
                <br />
                <br />
                <h1>🐯 ¿Qué es <em>Tiger Club</em>?</h1>
                <div className="section-with-image">
                    <div className="text-content">
                        <p>
                            <strong>Tiger Club</strong> es un club de andinismo apasionado por la aventura, la naturaleza y la exploración de las montañas.
                            Está formado por personas de todos los niveles —desde principiantes hasta expertos— que comparten el amor por el montañismo,
                            el trekking y la vida al aire libre.
                        </p>
                        <p>
                            Ya sea que quieras iniciarte en el mundo de la montaña o buscar nuevos retos en las cumbres más altas,
                            <strong> Tiger Club </strong> es tu espacio para crecer, aprender y vivir experiencias inolvidables.
                        </p>
                    </div>
                    <img src="/assets/images/carouselTyger/TigerClub.png" alt="Imagen representativa del club" className="section-image" />
                </div>

                <h2>🏕️ ¿Qué hacemos?</h2>

                <div className='row'>
                    <div className='col-12 col-sm-6'>
                        <div className="section-with-image">
                            <div className="text-content">
                                <h3>🚶‍♂️ Excursiones y Ascensos</h3>
                                <p>
                                    Organizamos salidas a montañas de diversos niveles de dificultad. Cada ruta es una nueva oportunidad para disfrutar del paisaje,
                                    explorar senderos naturales y conectar con la naturaleza.
                                </p>
                            </div>
                        </div>

                    </div>
                    <div className='col-12 col-sm-6'>
                        <div className="section-with-image">
                            <div className="text-content">
                                <h3>🏔️ Cultura y Conocimiento</h3>
                                <p>
                                    Nos encanta conocer la historia, cultura y geografía de las montañas, especialmente las joyas de la región andina.
                                    ¡Cada cumbre tiene una historia que contar!
                                </p>
                            </div>
                        </div>
                    </div>

                </div>


                <div className='row'>
                    <div className='col-12 col-sm-6'>
                        <div className="section-with-image">
                            <div className="text-content">
                                <h3>🌱 Compromiso Ambiental</h3>
                                <p>
                                    Nos preocupamos por el planeta. Promovemos prácticas sostenibles y responsables en cada salida.
                                    Amamos la montaña y la cuidamos como se merece.
                                </p>
                            </div>
                        </div>

                    </div>
                    <div className='col-12 col-sm-6'>

                    </div>
                </div>

                <h2>🎯 Nuestros Objetivos</h2>
                <ul>
                    <li>Fomentar el <strong>respeto por la naturaleza</strong> y el medio ambiente.</li>
                    <li>Promover la <strong>seguridad en la práctica del andinismo</strong> mediante capacitación adecuada.</li>
                    <li>Crear una comunidad unida que comparta aventuras, experiencias y valores como la <strong>camaradería y cooperación</strong>.</li>
                    <li>Ofrecer experiencias de <strong>crecimiento personal</strong>, superando desafíos físicos y mentales en cada expedición.</li>
                </ul>
                <br></br>

                <h2>🎁 Beneficios para Miembros del Tyger Club</h2>
                <p>
                    La comunidad para los amantes de la aventura, los viajes y las buenas experiencias 🐯🌍
                </p>
                <p>
                    ¿Te encanta salir de la rutina, explorar nuevos lugares y conectar con la naturaleza? En el Tyger Club te premiamos por hacerlo.
                    Al ser parte de nuestra comunidad, accedes a una serie de beneficios pensados para acompañarte en cada ruta:
                </p>

                <ul>
                    <li>🏕️ <strong>10% de descuento en alquiler de equipos de camping:</strong> Disfruta tus aventuras al aire libre con el mejor equipo, a un precio preferencial.</li>
                    <li>🎒 <strong>10% de descuento en la compra de productos:</strong> Equípate con lo mejor: mochilas, accesorios, termos y más con un 10% de descuento exclusivo.</li>
                    <li>🌄 <strong>10% de descuento en tours y rutas organizadas:</strong> Viaja más y paga menos. Todos nuestros tours tienen precio especial para ti como miembro.</li>
                    <li>🤝 <strong>Beneficios con aliados estratégicos:</strong> Accede a descuentos especiales con marcas y negocios aliados mientras tu suscripción esté activa.</li>
                    <li>🎂 <strong>¡Celebra tu cumpleaños viajando!:</strong> Si tu tour cae durante el mes de tu cumpleaños, tú y un acompañante reciben un 50% de descuento en ese viaje.(No aplica para cueva de los Tayos)</li>
                </ul>

                <h3>🕒 ¿Y por cuánto tiempo puedo disfrutar estos beneficios?</h3>
                <ul>
                    <li>🔸 <strong>Clientes regulares (sin membresía):</strong> disfrutan de beneficios con nuestros aliados durante un periodo limitado: 5 días antes y 5 días después de su tour.</li>
                    <li>🔸 <strong>Miembros del Tyger Club:</strong> tienen acceso completo a todos los beneficios durante todo el tiempo que su membresía esté activa, sin restricciones de fechas.</li>
                </ul>

                <h3>💳 Planes de Suscripción</h3>
                <ul>
                    <li>📅 <strong>Mensual:</strong> $10.00</li>
                    <li>📆 <strong>Trimestral (3 meses):</strong> $25.00</li>
                    <li>🗓️ <strong>Anual:</strong> $90.00</li>
                </ul>

                <p>
                    🎒 Además, al unirte con la membresía anual recibirás un <strong>Kit de Bienvenida exclusivo</strong> que incluye:
                    gorra, taza, tomatodo, llavero, agenda y un bolso.
                </p>

                <p>
                    Nuestros viajeros más fieles —quienes han realizado más de 5 rutas con nosotros— ya forman parte del Tyger Club con una membresia trimestral.
                    Recuerda que si la membresía no se encuentra al día, tu código QR de acceso a beneficios se desactiva hasta regularizar el pago.
                </p>

                <p>
                    🌟 <strong>¡Únete hoy y comienza a disfrutar de una experiencia de viaje diferente, donde cada paso que das te da más!</strong><br />
                    <strong>Tyger Club, donde tu aventura tiene recompensa 🐾</strong>
                </p>
                <br></br>

                <h2>📩 ¿Quieres unirte?</h2>
                <p>
                    Contáctanos para más información o para reservar tu lugar en nuestra próxima aventura:
                </p>
                <ul>
                    <li><strong>Teléfonos:</strong> 0997159098 – 0961119670 – 0993786135</li>
                    <li><strong>Email:</strong> campingchimborazo@gmail.com</li>
                </ul>
                <br></br>



            </div>

            <FooterScreen />
        </>
    );
};
